"use client";

import base from "lib/base";
import styles from "styles/components/app-section.module.css";
const AppSection = ({ appInfo }) => {
  const item = Array.isArray(appInfo) ? appInfo[0] : appInfo || null;

  const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  };

  const sanitizeTitleHtml = (html) => {
    if (!html) return "";
    return html
      .replace(/<(?!\/?(strong|span)\b)[^>]*>/gi, "")
      .replace(/<(strong|span)[^>]*>/gi, "<$1>")
      .replace(/<\/(strong|span)[^>]*>/gi, "</$1>");
  };

  const titleHtml = sanitizeTitleHtml(item?.name || "Gerelt App");
  const aboutText =
    stripHtml(item?.about) ||
    "Хөдөө орон нутаг, дэлхийн өнцөг булан бүрт суугаа монгол улаадаа эх хэл дээр хэвлэгдсэн ном, библи, подкастуудыг цаг алдалгүй хүргэх нь бидний эрхэм зорилго билээ. Үүнтэй зэрэгцэн эх хэлээ харах, мартагдсан номоо сэргээн сонсох боломжийг олгож байна.";
  const appStoreUrl = item?.appstore || "#";
  const googlePlayUrl = item?.googleplay || "#";
  const pictureRaw = item?.appPicture || item?.picture || "";
  const dynamicPicture = pictureRaw
    ? /^https?:\/\//i.test(pictureRaw)
      ? pictureRaw
      : `${String(base.cdnUrl || "").replace(/\/+$/, "")}/${String(
          pictureRaw,
        ).replace(/^\/+/, "")}`
    : "/assets/img/mergephone.png";
  return (
    <section className={styles.section}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className={styles.content}>
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: titleHtml }}
              />
              <p className={styles.text}>{aboutText}</p>
              <div className={styles.storeButtons}>
                <a
                  href={appStoreUrl}
                  className={styles.btn}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/assets/img/appstore.svg"
                    alt="Download on the App Store"
                    className={styles.btnImg}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.parentNode.textContent = "App Store";
                      e.target.parentNode.style.background = "#000";
                      e.target.parentNode.style.color = "#fff";
                      e.target.parentNode.style.display = "flex";
                      e.target.parentNode.style.alignItems = "center";
                      e.target.parentNode.style.justifyContent = "center";
                      e.target.parentNode.style.padding = "0 20px";
                      e.target.parentNode.style.borderRadius = "8px";
                    }}
                  />
                </a>
                <a
                  href={googlePlayUrl}
                  className={styles.btn}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/assets/img/googleplay.png"
                    alt="Get it on Google Play"
                    className={styles.btnImg}
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.parentNode.textContent = "Google Play";
                      e.target.parentNode.style.background = "#000";
                      e.target.parentNode.style.color = "#fff";
                      e.target.parentNode.style.display = "flex";
                      e.target.parentNode.style.alignItems = "center";
                      e.target.parentNode.style.justifyContent = "center";
                      e.target.parentNode.style.padding = "0 20px";
                      e.target.parentNode.style.borderRadius = "8px";
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className={styles.imageArea}>
              <img
                src={dynamicPicture}
                alt="Gerelt App"
                className={styles.mergePhone}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppSection;
